import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';

/**
 * 入力バリデーション 制御
 */
export default class InputValidationClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'InputValidationClass';

    this.EVENT_CHANGE = 'eventChange';

    this.CL_ERROR = 'error';

    this.STRING_ERROR_CLASS = '.input_error';
    this.TEMPLATE_ERROR = '<span class="input_error"></span>';

    this.parent = null;
    this.target = _target;
    this.isError = false;
    this.error = null;
    this.title = null;
    this.inputName = null;
    this.inputType = null;
    this.dataType = null;

    this.INPUT_TYPE_MULTI_SELECT = 'multi_select';
    this.INPUT_TYPE_RADIO = 'radio';
    this.INPUT_TYPE_SELECT = 'select';
    this.INPUT_TYPE_TEXT = 'text';
    this.INPUT_TYPE_EMAIL = 'email';
    this.INPUT_TYPE_PASSWORD = 'password';
    this.INPUT_TYPE_TEL = 'tel';
    this.INPUT_TYPE_CHECKBOX = 'checkbox';

    this.V_TYPE_REQUIRED = 'required';
    this.V_TYPE_ALPHABET = 'alphabet';
    this.V_TYPE_NUMBER = 'number';
    this.V_TYPE_ALPHABET_ONLY_LARGE = 'alphabetOl';
    this.V_TYPE_ALPHANUMERIC = 'alphanumeric';
    this.V_TYPE_KANA = 'kana';
    this.V_TYPE_EMAIL = 'email';
    this.V_TYPE_TEL = 'tel';
    this.V_TYPE_CARD_NAME = 'card_name';
    this.V_TYPE_CANT_ONLY_SPACE = 'cant_only_space';

    this.V_NULL = 100;
    this.V_KANA_ERROR = 101;
    this.V_ALPHABET_ERROR = 102;
    this.V_ALPHANUMERIC_ERROR = 103;
    this.V_NUMBER_ERROR = 104;
    this.V_ALPHABET_ONLY_LARGE_ERROR = 105;
    this.V_LENGTH_OVER_ERROR = 106;
    this.V_CANT_ONLY_SPACE_ERROR = 107;
    this.V_SELECT_ERROR = 400;
    this.V_TEL_ERROR = 200;
    this.V_TEL_KATA_ERROR = 201;
    this.V_MAIL_ERROR = 300;

    this.onChangeListener = this.onChange.bind(this);
  }

  onCreate() {
    //console.log(this.name, 'onCreate');
    this.inputName = this.target.attr('name');
    this.inputType = this.target.attr('type');

    if (!this.inputType) {
      let cl = this.target.attr('class');
      if (cl.indexOf('block_birthday') !== -1 || cl.indexOf('block_card_date') !== -1 || cl.indexOf('input_birthday') !== -1 || cl.indexOf('1input_birthdaysp') !== -1) {
        // 誕生日、カード有効期限
        this.inputType = this.INPUT_TYPE_MULTI_SELECT;
      } else if (cl.indexOf('block_radio_button_h') !== -1 || cl.indexOf('block_radio_button_v') !== -1 || cl.indexOf('block_radio_button') !== -1) {
        // ラジオボタン
        this.inputType = this.INPUT_TYPE_RADIO;
      } else if (cl.indexOf('css_select') !== -1 || cl.indexOf('-select') !== -1) {
        // セレクト
        this.inputType = this.INPUT_TYPE_SELECT;
      } else if (cl.indexOf('css_checkbox') !== -1 || cl.indexOf('-checkbox') !== -1) {
        // チェックボックス
        this.inputType = this.INPUT_TYPE_CHECKBOX;
      }
    }

    this.isMaxLength = (this.target.attr('data-max_length'));
    if (this.isMaxLength) {
      this.maxLength = this.target.attr('data-max_length') | 0;
    }

    switch (this.inputType) {
      case this.INPUT_TYPE_RADIO:
      case this.INPUT_TYPE_MULTI_SELECT:
        this.parent = this.target;
        this.title = $('dl dt', this.target).clone();
        break;
      default:
        this.parent = this.target.closest('dl');
        this.title = this.target.closest('dd').prev('dt').clone();
        break;
    }
    $('span,a', this.title).empty();
    // console.log(this.title.text());
    if (this.parent.length < 1) { this.parent = this.target; }

    this.type = this.target.attr('data-validation').split(',');

    this.isRequired = (this.type.indexOf(this.V_TYPE_REQUIRED) !== -1);
    //console.log(this.isRequired,this.inputType);

    switch (this.inputType) {
      case this.INPUT_TYPE_MULTI_SELECT:
      case this.INPUT_TYPE_RADIO:
        this.error = $(this.STRING_ERROR_CLASS, this.target);
        break;
      default:
        this.error = this.target.next(this.STRING_ERROR_CLASS);
        break;
    }

    this.target.on('blur', this.onChangeListener);
    // this.target.on("keyup",this.onChangeListener);

    switch (this.inputType) {
      case this.INPUT_TYPE_RADIO:
      case this.INPUT_TYPE_CHECKBOX:
      case this.INPUT_TYPE_SELECT:
        this.target.on('change', this.onChangeListener);
        break;
    }
  }

  onReset() {
    this.target.val('');
    this.errorClear();
  }

  onChange(e) {
    console.log(this.name, 'onChange');

    this.onCheck(true);

    this.jq.trigger(this.EVENT_CHANGE);
  }

  onCheck(_isAddError) {
    let re = false;
    if (!this.target.is(':hidden')) {
      //console.log(this.name, 'onCheck',this.inputType,this.target,this.isRequired);
      let val = this.target.val();
      let errorCode = -1;
      const self = this;
      if ((this.inputType === this.INPUT_TYPE_TEXT
        || this.inputType === this.INPUT_TYPE_EMAIL
        || this.inputType === this.INPUT_TYPE_TEL
        || this.inputType === this.INPUT_TYPE_PASSWORD)
        && this.isRequired && val === '') {
        // テキスト入力全般
        re = true;
        this.attentionChange(this.V_NULL, _isAddError);
      } else if (this.inputType === this.INPUT_TYPE_SELECT && this.isRequired) {
        // セレクトボックス
        // console.log("select",$("select", this.target).val());
        val = $('select', this.target).val();

        if (this.selectCheck(val)) {
          re = true;
          errorCode = this.V_SELECT_ERROR;
        }
        this.attentionChange(errorCode, _isAddError);
      } else if (this.inputType === this.INPUT_TYPE_RADIO && this.isRequired) {
        // ラジオボタン
        // console.log("radio",$("input:checked", this.target).val());
        val = $('input:checked', this.target).val();
        if (!val) {
          re = true;
          errorCode = this.V_SELECT_ERROR;
        }
        this.attentionChange(errorCode, _isAddError);
      } else if (this.inputType === this.INPUT_TYPE_MULTI_SELECT && this.isRequired) {
        // 複数のセレクトボックス
        let flag = false;
        $('select', this.target).each((index, element) => {
          let v = $(element).val();
          if (!flag && self.selectCheck(v)) { flag = true; }
        });
        if (flag) {
          re = true;
          errorCode = this.V_SELECT_ERROR;
        }
        this.attentionChange(errorCode, _isAddError);
      } else if (this.inputType === this.INPUT_TYPE_CHECKBOX && this.isRequired) {
        // チェックボックス
        val = $('input:checked', this.target).val();
        if (!val) {
          re = true;
          errorCode = this.V_SELECT_ERROR;
        }
        this.attentionChange(errorCode, _isAddError);
      } else if (val !== '') {
        let v = this.validateCheck(val);
        if (v !== -1) { re = true; }
        this.attentionChange(v, _isAddError);
      }
    }

    return { result: re, text: this.title.text(), parent: this.parent };
  }

  validateCheck(val) {
    let errorCode = -1;

    if (this.isMaxLength) {
      if (val.length > this.maxLength) {
        return this.V_LENGTH_OVER_ERROR;
      }
    }
    for (let k in this.type) {
      let type = this.type[k];

      switch (type) {
        case this.V_TYPE_NUMBER:
          if (!this.numberCheck(val)) {
            errorCode = this.V_NUMBER_ERROR;
          }
          break;
        case this.V_TYPE_KANA:
          if (!this.kanaCheck(val)) {
            errorCode = this.V_KANA_ERROR;
          }
          break;
        case this.V_TYPE_ALPHABET_ONLY_LARGE:
          if (!this.alphabetOnlyLargeCheck(val)) {
            errorCode = this.V_ALPHABET_ONLY_LARGE_ERROR;
          }
          break;
        case this.V_TYPE_EMAIL:
          if (!this.mailCheck(val)) {
            errorCode = this.V_MAIL_ERROR;
          }
          break;
        case this.V_TYPE_TEL:
          if (!this.numberCheck(val) || (val.length !== 10 && val.length !== 11)) {
            errorCode = this.V_TEL_KATA_ERROR;
            return errorCode;
          }
          if (!this.telCheck(val)) {
            errorCode = this.V_TEL_ERROR;
          }
          break;
        case this.V_TYPE_CARD_NAME:
          if (!val.match(/^[A-Z\s]+$/)) {
            errorCode = this.V_ALPHABET_ONLY_LARGE_ERROR;
          }
          break;
        case this.V_TYPE_CANT_ONLY_SPACE:
          if (val.match(/^[\s|　]+$/)) {
            errorCode = this.V_CANT_ONLY_SPACE_ERROR;
          }
          break;
      }
      if (errorCode !== -1) { break; }
    }

    return errorCode;
  }

  attentionChange(val, _isAddError) {
    let text = '';
    switch (val) {
      case this.V_NULL:
        text = LtikeCommon.TEXT.ERROR_INPUT_VALIDATION_NULL;
        break;
      case this.V_LENGTH_OVER_ERROR:
        text = this.maxLength + LtikeCommon.TEXT.ERROR_INPUT_VALIDATION_LENGTH_OVER_ERROR;
        break;
      case this.V_NUMBER_ERROR:
        text = LtikeCommon.TEXT.ERROR_INPUT_VALIDATION_NUMBER_ERROR;
        break;
      case this.V_KANA_ERROR:
        text = LtikeCommon.TEXT.ERROR_INPUT_VALIDATION_KANA_ERROR;
        break;
      case this.V_ALPHABET_ERROR:
        text = LtikeCommon.TEXT.ERROR_INPUT_VALIDATION_ALPHABET_ERROR;
        break;
      case this.V_ALPHABET_ONLY_LARGE_ERROR:
        text = LtikeCommon.TEXT.ERROR_INPUT_VALIDATION_ALPHABET_ONLY_LARGE_ERROR;
        break;
      case this.V_SELECT_ERROR:
        text = LtikeCommon.TEXT.ERROR_INPUT_VALIDATION_SELECT_ERROR;
        break;
      case this.V_ALPHANUMERIC_ERROR:
        text = LtikeCommon.TEXT.ERROR_INPUT_VALIDATION_ALPHANUMERIC_ERROR;
        break;
      case this.V_TEL_ERROR:
        text = LtikeCommon.TEXT.ERROR_INPUT_VALIDATION_TEL_ERROR;
        break;
      case this.V_TEL_KATA_ERROR:
        text = 'ハイフンなし10～11桁で入力してください';
        break;
      case this.V_MAIL_ERROR:
        text = LtikeCommon.TEXT.ERROR_INPUT_VALIDATION_MAIL_ERROR;
        break;
      case this.V_CANT_ONLY_SPACE_ERROR:
        text = LtikeCommon.TEXT.ERROR_INPUT_VALIDATION_ONLY_SPACE_ERROR;
        break;
    }

    if (text !== '') {
      if (_isAddError) { this.errorAdd(text); }
    } else {
      this.errorClear();
    }
    // console.log(this.name,"attentionChange",text);
  }

  errorAdd(_text) {
    if (!this.error || this.error.length <= 0) {
      switch (this.inputType) {
        case this.INPUT_TYPE_MULTI_SELECT:
        case this.INPUT_TYPE_RADIO:
          this.error = $(this.STRING_ERROR_CLASS, this.target);
          if (this.error.length < 1) {
            this.error = $(this.TEMPLATE_ERROR).appendTo(this.target);
          }
          break;
        default:
          this.error = this.target.next(this.STRING_ERROR_CLASS);
          if (this.error.length < 1) {
            this.error = $(this.TEMPLATE_ERROR).insertAfter(this.target);
          }
          break;
      }
    }
    this.error.show().text(_text);
    this.target.addClass(this.CL_ERROR);
    switch (this.inputType) {
      case this.INPUT_TYPE_RADIO:
      case this.INPUT_TYPE_MULTI_SELECT:
        $('label', this.target).addClass(this.CL_ERROR);
        break;
    }
    this.isError = true;
  }

  errorClear() {
    if (this.error) { this.error.html('').hide(); }
    this.target.removeClass(this.CL_ERROR);
    switch (this.inputType) {
      case this.INPUT_TYPE_RADIO:
      case this.INPUT_TYPE_MULTI_SELECT:
        $('label', this.target).removeClass(this.CL_ERROR);
        break;
    }
    this.isError = false;
    //console.log(this.name, 'errorClear', this.inputType);
  }

  selectCheck(val) {
    return val === '-' || val === '選択してください' || val === '--' || val === '';
  }

  kanaCheck(val) {
    return val.match(/^[ァ-ヶー]+$/);
  }

  numberCheck(val) {
    return val.match(/^[0-9]+$/);
  }

  alphabetCheck(val) {
    return val.match(/^[a-zA-Z]+$/);
  }

  alphabetOnlyLargeCheck(val) {
    return val.match(/^[A-Z]+$/);
  }

  alphanumericCheck(val) {
    return val.match(/^[a-zA-Z0-9]+$/);
  }

  telCheck(val) {
    return val.match(/^[0-9]{10}$|^[0-9]{11}$/);
  }

  mailCheck(val) {
    // copy http://emailregex.com/
    return val.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  }
}
